import { EmptyContentMessage } from '@/components/layout/empty-content-message';
import { useTranslations } from 'next-intl';

export const NoGamesManager = () => {
	const t = useTranslations('General');
	return (
		<EmptyContentMessage
			type="sport"
			title={t.raw('NoGame')}
		>
		</EmptyContentMessage>
	);
};